import { downloadAdvancedSearchResults } from "./downloadAdvancedSearchResults";

export const handleDownloadAdvancedSearch = async (suggestionsData: any[], searchType: string, selectedFilter: string, text: string, totalSearched: number) => {

    try {
      await downloadAdvancedSearchResults({
        suggestionsData,
        searchType,
        selectedFilter,
        text,
        totalSearched,
        totalFound: suggestionsData.filter((item: any) => item.found).length,
      });
    } catch (error) {
      console.error("Error downloading results:", error);
    }
  };